function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.742 7.358l-5.984 2.51.01.25 1.31-.044-.702 2.688v2.135l2.565 6.514 3.58 8.413c-.69.32-1.77.249-2.247-.597l-3.61-6.347-1.982-3.2v-1.826l-.194-.113-.914 1.523-2.239 3.616-3.608 6.347c-.478.846-1.558.917-2.249.597l3.582-8.413 2.564-6.514v-2.135l-.924-3.54-4.442-1.864-4.806-2.935c-.54-.406-.52-.857-.332-1.267l6.234 2.768 4.411.982h4.47l4.41-.982 6.236-2.768c.187.41.206.86-.334 1.267l-4.805 2.935zm-9.717-2.409V3.591c0-.879.732-1.591 1.636-1.591.904 0 1.636.712 1.636 1.591v1.358c-.29.681-.913 1.152-1.636 1.152-.723 0-1.346-.47-1.636-1.152z",
  fill: "currentColor"
})));